import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Expand from './icon-expand.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Expand {...validProps} />;
}
SvgComponent.iconName = 'expand';

export const ExpandIcon = svgIconWrapper(SvgComponent);
